import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { rememberReferral } from './referralStore';

/** Reads `?ref=` once per navigation, holds the code, and strips it from the URL. */
export function useReferralQuery(): void {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    if (ref === null) return;
    rememberReferral(ref);
    params.delete('ref');
    const search = params.toString();
    void navigate(
      {
        pathname: location.pathname,
        search: search.length > 0 ? `?${search}` : '',
        hash: location.hash,
      },
      { replace: true },
    );
  }, [location.hash, location.pathname, location.search, navigate]);
}
